import * as THREE from 'three';
import { windowOutline } from '../configurator/windowShapes';
import { applyMetricUVs } from '../scene/materialGeometry';

// The reveal uses the SAME opening outline as the customer's product. OpenAI
// only supplies the scenery visible beyond the glass, never redraws the frame.
export function addConceptArchitecture(model, design, fixed, materials) {
  model.group.position.y = fixed ? .8 : 0;
  for (const run of model.runs) {
    const span = Math.max(run.width, run.height) * 4;
    const wall = new THREE.Shape([new THREE.Vector2(-span, -span), new THREE.Vector2(span, -span), new THREE.Vector2(span, span), new THREE.Vector2(-span, span)]);
    const outline = windowOutline(fixed ? design.window_shape || 'rectangle' : 'rectangle', run.width + .004, run.height + .002);
    wall.holes.push(new THREE.Path(outline.map(([x, y]) => new THREE.Vector2(x, y))));
    const mesh = new THREE.Mesh(new THREE.ExtrudeGeometry(wall, { depth: .18, bevelEnabled: false, steps: 1 }), materials.wall);
    mesh.name = 'concept-wall-reveal'; mesh.position.z = run.depth / 2 - .184;
    mesh.receiveShadow = true; run.group.add(mesh);
    applyMetricUVs(mesh);
  }
}